enum OrderType {
  Standard = 0,
  NoSample = 1
}

export default OrderType;
